export default __webpack_public_path__ + "static/icon-tie-front-b77fda07b9782384433dfb00e3349d17.webp";